<template>
  <v-row no-gutters class="sidebar-object-added-row" align="center">
    <v-col cols="auto" class="sidebar-object-added-text">
      {{ getObjectText }}
    </v-col>
    <v-spacer />
    <template v-if="hasPermissions">
      <v-col cols="auto">
        <v-tooltip bottom color="font">
          <template #activator="{on}">
            <div v-on="on">
              <v-icon size="18px" @click="zoomToObject">mdi-magnify</v-icon>
            </div>
          </template>
          {{ $i18n.t('dialog.zoomToObject') }}
        </v-tooltip>
      </v-col>
      <v-col cols="auto" v-if="!isNewInstance && readonly">
        <v-tooltip bottom color="font">
          <template #activator="{on}">
            <div v-on="on">
              <v-icon size="18px" @click="openObjectCard">mdi-file-document</v-icon>
            </div>
          </template>
          {{ $i18n.t('dialog.openObjectCard') }}
        </v-tooltip>
      </v-col>
    </template>
    <v-col cols="auto">
      <dots-menu :disabled="readonly" font-size="18px" :items="dotsMenuItems" @delete="deleteObject"></dots-menu>
    </v-col>
  </v-row>
</template>

<script>
import DotsMenu from '@/components/DotsMenu';

export default {
  name: 'SidebarObjectAdded',
  components: {
    DotsMenu,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    layerName: {
      type: String,
      required: true,
    },
    isNewInstance: {
      type: Boolean,
      default: false,
    },
    hasPermissions: {
      type: Boolean,
      default: false,
    },
    propertyName: {
      type: String,
      default: 'object_id',
    },
    propertyTranslation: {
      type: String,
      default: 'ID',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dotsMenuItems: [
      {
        name: 'delete',
      },
    ],
  }),
  computed: {
    getObjectText() {
      return `${this.layerName}: ${this.propertyTranslation} ${this.value[this.propertyName]}`;
    },
  },
  methods: {
    deleteObject() {
      this.$emit('deleteObject');
    },
    openObjectCard() {
      this.$router.push({
        name: 'layerFeature',
        params: {
          lid: this.value.layer_id,
          fid: this.value.object_id,
        },
      });
    },
    zoomToObject() {
      this.$root.$emit('isLayerVisibleWithCallback', this.value.layer_id, () => {
        this.$root.$emit('isFeatureVisible', this.value.layer_id, this.value.object_id, {
          callback: isVisible => {
            if (!isVisible) {
              this.$store.set('snackbar/PUSH_MESSAGE!', {
                message: this.$i18n.t('map.featureFilteredOut'),
              });
            } else {
              this.$root.$emit('zoomToFeature', this.value.layer_id, 'layers', this.value.object_id);
            }
          },
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.sidebar-object-added-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 15px;
  color: rgba(0, 0, 0, 0.7);
}
.sidebar-object-added-row {
  height: 24px;
}
</style>
